import { HttpErrorResponse } from '@angular/common/http';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ChangeDetectorRef, Component, EventEmitter, OnInit, Output, inject, DestroyRef ,
  ChangeDetectionStrategy,
} from '@angular/core';
import {UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import { DSTSharedService } from 'projects/gtw-elements/src/app/DST/shared/dst-shared.service';
import { TaxTypePipe } from 'projects/gtw-elements/src/app/DST/shared/pipes/taxtype.pipe';
import { MessageService } from 'projects/gtw-elements/src/app/DST/shared/services/message.service';
import { EMPTY, forkJoin, Observable, of, switchMap, tap } from 'rxjs';
import {StmtAttrData, StmtData } from '../../../../../../shared/models/dst-form-state.model';
import { TrackerTabsService, TrackerTabState } from '../../../../../tracker-tabs.service';
import {CreateDisclosureSharedService, DropDownType, dstLookupEntity, EntityNameChange} from '../../../create-disclosure-shared.service';

@Component({
    selector: 'dst-view-template-sec368-id188',
    templateUrl: './view-template-sec368-id188.component.html',
    styleUrls: ['../../template-shared.scss', './view-template-sec368-id188.component.scss'],
    standalone: false,
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class ViewTemplateSec368Id188Component implements OnInit {
  private readonly destroyRef = inject(DestroyRef);


  @Output('onCancel') onCancel: EventEmitter<null> = new EventEmitter<null>();

  startLoader: boolean = false;
  disableActions: boolean = false;
  stmtData!: StmtData;
  stmtAttrData: any = [];
  loaded: boolean = false;
  attrData: any = [];
  form188!: UntypedFormGroup;
  currencyOptions: any = [];
  propertyValBasisOptions: any = [];
  attMap: any = {};
  prEntityNull: boolean = false;
  secEntityNull: boolean = false;
  lookupdata: any = [];
  shdspLeid: boolean = false;
  pickListVal: string = '';
  selBasisTxt: string = '';
  descTotalAvl: boolean = false;
  selBasisTxtOthr: string = '';
  s3Uploading: boolean = false;
  primaryCorpTypeTxt: string = '';
  secondaryCorpTypeTxt: string = '';
  shCorpTypeTxt: string = '';
  primaryEntityName: string = '';
  secondaryEntityName: string = '';

  constructor(private formBuilder: UntypedFormBuilder,
              private sharedService: CreateDisclosureSharedService,
              private dstSharedService: DSTSharedService,
              private taxTypePipe: TaxTypePipe,
              private trackerTabsService: TrackerTabsService,
              private messageService: MessageService,
              private cdr: ChangeDetectorRef) {
    this.disableActions = this.sharedService.disableActions;
    this.sharedService.disableActions = false; // reset immediately after consumed
  }

  ngOnInit(): void {
    this.startLoader = true;
    this.form188 = this.formBuilder.group({
      header: this.formBuilder.group({
        consolGroup: ['', Validators.required],
        options: ['']
      })
    });

    //load currencies
    this.sharedService.getCurrencyDropdown().pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((data: DropDownType[]) => {
        data.forEach(element => {
          this.currencyOptions.push({
            value: element.id,
            label: element.text
          });
        });
      }, () => {

      }, () => {

      });
    //PropertyValBasis Options
    this.sharedService.getBasisDropdown().pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((data: DropDownType[]) => {
        //console.log(data);
        data.forEach(element => {
          this.propertyValBasisOptions.push({
            value: element.id,
            label: element.text
          });
        });
      }, () => {

      }, () => {

      });

    //load Stmt data
    this.sharedService.getLoadStatementData(188).pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((response: StmtData) => {
        this.stmtData = response;
        this.primaryEntityName = this.stmtData.primaryentity || '';
        this.secondaryEntityName = this.stmtData.secondaryentity || '';

        //load all attributes into new object for showing on UI as key value pair
        this.attMap = {};

        this.stmtData.children?.forEach((stmt: StmtAttrData) => {
          if (!this.attMap[stmt.attributeName]) {
            this.attMap[stmt.attributeName] = [];
          }

          if (stmt.attributeValue !== undefined) {

            this.attMap[stmt.attributeName]?.push(stmt.attributeValue);
          } else {
            //console.log('stmt.attributeName---'+ stmt.attributeName);
            this.attMap[stmt.attributeName]?.push(undefined);
          }

        });
        if(this.attMap['LiquidationDate'] && this.attMap['LiquidationDate'][0]){
          const trackerTab: TrackerTabState | null = this.trackerTabsService.getActiveTrackerTab();

          trackerTab!.parentTransDate = this.attMap['LiquidationDate'][0];

          this.messageService.broadcast(trackerTab?.id!,"368-on-transDate-set");
        }
        console.log('After loop Attr data' + JSON.stringify(this.attMap));

        //check primary and secondary
        if (this.stmtData.primaryentityid === null || this.stmtData.primaryentityid === undefined) {
          this.prEntityNull = true;
        }
        if (this.stmtData.secondaryentityid === null || this.stmtData.secondaryentityid === undefined) {
          this.secEntityNull = true;
        }
        //check totals are available
        if (this.attMap['Desc'] && this.attMap['Desc'].length >= 1) {
          this.descTotalAvl = true;
        }
        //if (this.attMap['Desc1'] && this.attMap['Desc1'].length >= 1) { this.basisAmt1Total = true }

        this.propertyValBasisOptions.forEach((val: { value: any; label: string }) => {

          if ((this.attMap['Basis'] !== undefined) && (val.value == this.attMap['Basis'][0])) {
            this.selBasisTxt = val.label;
          }
          if ((this.attMap['Basis'] !== undefined) && (val.value == this.attMap['Basis'][1])) {
            this.selBasisTxtOthr = val.label;
          }

        });
        //pickList val
        //Select pickList Val
        // Flatten the previous 3-level nested subscribe chain
        // (getLiquidationStateDropdown → getDSTEntityInfo → updateEntitiesInfo)
        // into a single switchMap pipeline. The downstream observable is
        // EMPTY when no transferor LEID is present so the pdf-upload still
        // runs in the .else branch above.
        this.sharedService
          .getLiquidationStateDropdown(4)
          .pipe(
            tap((data: DropDownType[]) => {
              data.forEach((element) => {
                if (
                  this.attMap['CodeSection'] &&
                  element.id == this.attMap['CodeSection'][0]
                ) {
                  this.pickListVal = element.text;
                }
              });
            }),
            switchMap(() => {
              const transferorLeid =
                this.attMap['SHdspTransferorLEID'] &&
                this.attMap['SHdspTransferorLEID'][0];
              if (transferorLeid === undefined) {
                this.loadOtherEntitiesInfoAndUploadPdf();
                return EMPTY;
              }
              return this.sharedService.getDSTEntityInfo(transferorLeid).pipe(
                switchMap((entity: dstLookupEntity[]) => {
                  if (!entity) return EMPTY;
                  this.shdspLeid = true;
                  this.lookupdata.push(entity[0]);
                  return this.updateEntitiesInfo(
                    this.lookupdata[0].LEID,
                    3,
                  ).pipe(tap(() => this.loadOtherEntitiesInfoAndUploadPdf()));
                }),
              );
            }), takeUntilDestroyed(this.destroyRef),
          )
          .subscribe();


      }, () => {

      }, () => {

      }).add(() => {
      this.loaded = true;
      this.startLoader = false;
    //   setTimeout(() => {
    //     const html = document.querySelector('#temp368form188');
    //     const htmlContent = html!.outerHTML;

    //     this.sharedService.getFormStateByFormId(188)!.doPDFSync && this.htmlToPdfConversion(htmlContent.toString());
    //   });
    //
    });

  }

  private loadOtherEntitiesInfoAndUploadPdf() {
    forkJoin([
      this.updateEntitiesInfo(this.stmtData?.primaryleid!, 1),
      this.updateEntitiesInfo(this.stmtData?.secondaryleid!, 2)
    ]).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(([response1, response2]) => {
      this.cdr.detectChanges();

      requestAnimationFrame(() => {
        setTimeout(() => {
          const html = document.querySelector('#temp368form188');
          const htmlContent = html!.outerHTML;
          this.sharedService.getFormStateByFormId(188)!.doPDFSync && this.htmlToPdfConversion(htmlContent.toString());
        }, 0);
      });
    }, (error: HttpErrorResponse) => {

      console.log(error);
      this.dstSharedService.showAlert('error', error.message);

    }).add(() => {
      this.loaded = true;
      this.startLoader = false;
    });
  }

  htmlToPdfConversion(htmlContent: string, isS3upload: boolean = false): void {
    this.sharedService.saveHTMLToPDFStatement(htmlContent!, 'Section368-StatementPursuant.pdf', this.stmtData.statementid).pipe(takeUntilDestroyed(this.destroyRef))
    .subscribe((response: any) => {
      isS3upload && (this.dstSharedService.showAlert('success', 'The Form got successfully uploaded to S3!'));
      isS3upload && (this.s3Uploading =  false);
    }, (eMsg: string) => {
      console.log(eMsg);
      isS3upload && (this.dstSharedService.showAlert('error', eMsg));
    });
  }

  s3Upload(): void {
    this.s3Uploading = true;
    const html = document.querySelector('#temp368form188');
    const htmlContent = html!.outerHTML;
    this.htmlToPdfConversion(htmlContent, true);
  }

  //getCurrencyText
  getSelCurrency(valFor?: number): string {
    let retVal = '';
    this.currencyOptions.forEach((val: { value: any; label: string }) => {
      if (this.attMap['Currency'] && val.value == this.attMap['Currency'][0] && valFor == 0) {
        retVal = val.label;
      } else if (this.attMap['Currency'] && val.value == this.attMap['Currency'][1] && valFor == 1) {

        retVal = val.label;
      } else if (this.attMap['Currency'] && val.value == this.attMap['Currency'][2] && valFor == 2) {

        retVal = val.label;
      } else if (this.attMap['Currency'] && val.value == this.attMap['Currency'][3] && valFor == 3) {

        retVal = val.label;
      }

    });

    return retVal;
  }

  totalAmt(amtFor?: String): number {
    let totalAmt = 0;
    const addAmt = (amt: any) => {
      const value = Number(String(amt ?? '').replace(/,/g, ''));
      if (Number.isFinite(value)) {
        totalAmt += value;
      }
    };
    if (amtFor == 'BasisAmt' && this.attMap['BasisAmt'] !== undefined) {
      this.attMap['BasisAmt'].forEach(addAmt);
    } else if (amtFor == 'FMVAmt' && this.attMap['FMVAmt'] !== undefined) {
      this.attMap['FMVAmt'].forEach(addAmt);
    } else if (amtFor == 'BasisAmt1' && this.attMap['BasisAmt1'] !== undefined) {
      this.attMap['BasisAmt1'].forEach(addAmt);
    } else if (amtFor == 'FMVAmt1' && this.attMap['FMVAmt1'] !== undefined) {
      this.attMap['FMVAmt1'].forEach(addAmt);
    }
    return totalAmt;
  }

  // updateEntitiesInfo(leid: string, entityType: number): void {
  //   this.startLoader = true;
  //   this.sharedService.checkForEntityNameChange(this.stmtData?.statementid.toString(),
  //     leid,
  //     this.sharedService.getTransDateStr(this.attMap['LiquidationDate'][0],1),
  //     this.sharedService.getActiveFormState().taxYear.toString()
  //   ).subscribe((response: EntityNameChange[]) => {
  //     if (response && response[0]) {
  //       //override entity type
  //       const corpType = this.taxTypePipe.transform(response[0], response[0].TAXTYPECODE, true);
  //       if (entityType === 1) { //primary entity
  //         (response[0].LE_NAME) && (this.primaryEntityName = response[0].LE_NAME);
  //         this.primaryCorpTypeTxt = corpType;
  //       } else if (entityType === 2) { //secondary entity
  //         (response[0].LE_NAME) && (this.secondaryEntityName = response[0].LE_NAME);
  //         this.secondaryCorpTypeTxt = corpType;
  //       } else if (entityType === 3) { //share holder entity
  //         (response[0].LE_NAME) && (this.lookupdata[0].ENTITY = response[0].LE_NAME);
  //         this.shCorpTypeTxt = corpType;
  //       }
  //     }
  //   }, (error: HttpErrorResponse) => {
  //     console.log(error);
  //     this.dstSharedService.showAlert('error', error.message);
  //   }).add(() => {
  //     this.startLoader = false;
  //   });
  // }

  updateEntitiesInfo(leid: string, entityType: number): Observable<EntityNameChange[]> {
    this.startLoader = true;
    return this.sharedService.checkForEntityNameChange(this.stmtData?.statementid.toString(),
      leid,
      this.sharedService.getTransDateStr(this.attMap['LiquidationDate'][0],1),
      this.sharedService.getTaxYearStr(this.stmtData)
    ).pipe(
      tap({
        next: (response => {
          if (response && response[0]) {
              //override entity type
              const corpType = this.taxTypePipe.transform(response[0], response[0].TAXTYPECODE, true);
              if (entityType === 1) { //primary entity
                (response[0].LE_NAME) && (this.primaryEntityName = response[0].LE_NAME);
                this.primaryCorpTypeTxt = corpType;
              } else if (entityType === 2) { //secondary entity
                (response[0].LE_NAME) && (this.secondaryEntityName = response[0].LE_NAME);
                this.secondaryCorpTypeTxt = corpType;
              } else if (entityType === 3) { //share holder entity
                (response[0].LE_NAME) && (this.lookupdata[0].ENTITY = response[0].LE_NAME);
                this.shCorpTypeTxt = corpType;
              }
		       }
        })
      })
    )
  }

  dummyFunc(event: any): void {

  }

  save(): void {
    this.sharedService.setFormData(this.stmtData);
    this.sharedService.setSavedStatementId(this.stmtData.statementid.toString());
    this.sharedService.switchTemplateMode(false);
  }

  cancel(): void {
    this.onCancel.emit();
  }

}
